import { useSync } from '../contexts/SyncContext';
import {
  ArrowPathIcon,
  CloudArrowUpIcon,
  ExclamationTriangleIcon,
} from '@heroicons/react/24/outline';

export function OfflineIndicator() {
  const { isOnline, isSyncing, pendingSyncItems } = useSync();

  if (isOnline && !isSyncing && pendingSyncItems === 0) {
    return null; // Don't show anything when everything is normal
  }

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-4 max-w-sm">
        {/* Offline indicator */}
        {!isOnline && (
          <div className="flex items-center text-yellow-600">
            <ExclamationTriangleIcon className="w-5 h-5 mr-2 flex-shrink-0" />
            <div>
              <p className="font-medium text-sm">You're offline</p>
              <p className="text-xs text-gray-600 mt-1">
                Changes will sync when you're back online
              </p>
            </div>
          </div>
        )}

        {/* Syncing indicator */}
        {isOnline && isSyncing && (
          <div className="flex items-center text-blue-600">
            <ArrowPathIcon className="w-5 h-5 mr-2 animate-spin flex-shrink-0" />
            <div>
              <p className="font-medium text-sm">Syncing data...</p>
              <p className="text-xs text-gray-600 mt-1">
                Please wait while we sync your changes
              </p>
            </div>
          </div>
        )}

        {/* Pending sync items */}
        {isOnline && !isSyncing && pendingSyncItems > 0 && (
          <div className="flex items-center text-orange-600">
            <CloudArrowUpIcon className="w-5 h-5 mr-2 flex-shrink-0" />
            <div>
              <p className="font-medium text-sm">
                {pendingSyncItems} {pendingSyncItems === 1 ? 'change' : 'changes'} pending
              </p>
              <p className="text-xs text-gray-600 mt-1">
                Will sync automatically
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
